import {
  ANNUAL_HOUR_TRACKER,
  RAW_EXAM_DATA,
  REGIONALPRACTICE,
  SITE_LIST,
  UNASSIGNED_SITES,
} from "./routes";

export const EXPORT_MODULE = {
  REGIONAL_PRACTICE_WORKLIST: "Regional Practice Worklist",
  REGION: "Region",
  NATIONAL: "National",
  WORKLIST: "Worklist",
  PRACTICE: "Practice",
  SUB_PRACTICE: "Sub Practice",
  SECTION_WORKLIST_MAPPING: "Section-Worklist Mapping",
  USER_MANAGEMENT: "Provider User",
  RAD_TYPE: "Provider Type",
  RAD_STATUS: "Provider Status",
  RAD_DEGREE: "Provider Title",
  RAD_COMMUNICATION_TYPE: "Provider Communication Type",
  SCHEDULE_TYPE: "Schedule Type",
  SUB_SPECIALITY: "Subspecialty",
  BILLING_MANAGEMENT: "Billing Management",
  WEEK_ROTATION: "Week Rotation",
  RVU_RATE: "Provider RVU Rate",
  PARTNERSHIP_RATE: "Provider Partnership Rate",
  PARTNERSHIP_STATUS: "Provider Partnership Status",
  PARTNERSHIP_TIME: "Provider Partnership Time",
  REQUEST_STATUS: "Provider Schedule Request Status",
  COMMITTEES: "Provider Committees",
  FUTURE_SECTION_CHANGE: "Provider Schedule Future Section",
  RPCE: "RPCE",
  WORKLIST_DEFINITION: "Worklist Definition",
  WORKLIST_GROUP: "Worklist Group",
  TRAUMA_FACILITY_LEVEL: "Trauma Facility Level",
  SITE_STATUS: "Facility Status",
  QGENDA_SECTION: "Encore Section",
  RAD: "ProviderList",
  UNASSIGNED_PROVIDER_LIST: "UnassignedProviderList",
  STATE_LICENSE: "StateLicense",
  SITE: "Facility",
  RVURATE: "Provider RVU Rate",
  TIME_ZONE: "TimeZone",
  SITE_COVERAGE: "Facility Coverage",
  COVERAGE_GAP_COLOR_CONFIGURATION: "CoverageGapColorConfiguration",
  PRIORITY_SLA: "Priority Mapping",
  SHIFT_HOUR_CONFIGURATION: "Shift Hour Configuration",
  LICENSE_MAPPING: "License Mapping",
  PRIVILEGES_MAPPING: "Privileges Mapping",
  READING_STATUS_MAPPING: "Reading Status Mapping",
  DEFINE_MISMATCH: "Define Mismatch",
  DLS_CONFIGURATION: "DLS Configuration",
  SITES_WITHOUT_DLS: "Facilities Without DLS",
  BLOCK_PLANNING_COLOR_CONFIGURATION: "BlockPlanningColorConfiguration",
  TASK_CONFIGURATION: "TaskConfiguration",
  SIMULATOR_COLOR_CONFIGURATION: "SimulatorColorConfiguration",
  HOLIDAY_DEMAND_PLANNER: "Holiday Demand Planner",
  RAW_EXAM_DATA: "Raw Exam Data",
  TAT_DATA: "TAT Data",
  EXAM_DATA: "Exam Data",
  RAD_PROFILE_ASSOCIATED_SITES: "ProviderProfileAssociatedFacilities",
  RAD_CAPACITY: "Rad Capacity",
  RAD_CAPACITY_FILE: "Rad Capacity files",
  ANNUAL_HOUR_TRACKER: "Annual Hour Tracker",
  CUSTOM_VIEW_LIST: "Custom View List",
  UNASSIGNED_SITE_LIST: "UnassignedFacilityData",
  READ: "Read",
  UNREAD: "Unread",
  MISCELLANEOUS_SITE_DATA: "MiscellaneousFacilityData",
  SITE_LIST: "Facility List",
  SITE_ALIAS: "Facility Alias",
  SISTER_SITE: "Sister Facility",
  ONBOARDING_SITE_DEMAND_PLANNER: "Onboarding Facility Demand Planner",
  MATRIX_SERVICE_REQUEST_SITE_ONBOARDING:
    "Encore Service Request Facility Onboarding",
  CAPACITY_VS_DEMAND: "Capacity vs Demand",
  SCHEDULING_CALENDAR: "Scheduling Calendar",
  PROVIDER_REQUEST: "Provider Request",
  REGIONAL_PRACTICE: "Regional Practice",
  VOLUME_TREND_REPORT: "Volume Trend Report",
  STAFF_CATEGORY: "Provider Category",
  STAFF_PRIMARY_LOCATION: "Staff Primary Location",

  MODALITY: "Modality",
  PRIORITY: "Priority",
  SPECIALTY_CASES: "Specialty Cases",
  STAFFING_AGENCY: "Staffing Agency / Entity",
  PROVIDER_DOC_TYPE: "Provider Document Category",
  PROVIDER_NOTE_TYPE: "Note Category",
  DESIGNATION_USER: "User Designations",
};

export const EXPORT_APIURL = {
  REGIONAL_PRACTICE_WORKLIST: "RegionalPracticeWorklist/ExportToCSV",
  REGION: "Region/ExportToCSV",
  NATIONAL: "National/ExportToCSV",
  WORKLIST: "WorkList/ExportToCSV",
  PRACTICE: "Practice/ExportToCSV",
  SUB_PRACTICE: "SubPractice/ExportToCSV",
  PRIORITY_SLA: "PrioritySLA/ExportToCSV",
  SECTION_WORKLIST_MAPPING: "RadSection/ExportToCSV",
  USER_MANAGEMENT: "RadUser/ExportToCSV",
  RAD_TYPE: "RadType/ExportToCSV",
  RAD_STATUS: "RadStatus/ExportToCSV",
  RAD_DEGREE: "RadDegree/ExportToCSV",
  RAD_COMMUNICATION_TYPE: "RadCommunicationType/ExportToCSV",
  SCHEDULE_TYPE: "ScheduleType/ExportToCSV",
  SUB_SPECIALITY: "SubSpeciality/ExportToCSV",
  BILLING_MANAGEMENT: "BillingManagement/ExportToCSV",
  WEEK_ROTATION: "WeekRotation/ExportToCSV",
  RVU_RATE: "RadRUVRate/ExportToCSV",
  PARTNERSHIP_RATE: "RadPartnershipRate/ExportToCSV",
  PARTNERSHIP_STATUS: "RadPartnershipStatus/ExportToCSV",
  PARTNERSHIP_TIME: "RadPartnershipTime/ExportToCSV",
  REQUEST_STATUS: "RadScheduleRequestStatus/ExportToCSV",
  COMMITTEES: "RadCommittees/ExportToCSV",
  FUTURE_SECTION_CHANGE: "RadScheduleFutureSection/ExportToCSV",
  RPCE: "RPCE/ExportToCSV",
  WORKLIST_DEFINITION: "WorklistDefinition/ExportToCSV",
  WORKLIST_GROUP: "WorklistGroup/ExportToCSV",
  TRAMA_FACILITY_LEVEL: "TramaFacilityLevel/ExportToCSV",
  SITE_STATUS: "SiteStatus/ExportToCSV",
  QGENDA_SECTION: "RadQGendaSection/ExportToCSV",
  RAD: "Radiologist/ExportToCSV",
  UNASSIGNED_PROVIDER_LIST: "Radiologist/ExportUnassignedProvidersToCSV",
  STATE_LICENSE: "StateLicense/GetAllStateLicenseExport",
  SITE: "SiteManagement/ExportToCSV",
  RVURATE: "RadRUVRate/ExportToCSV",
  TIME_ZONE: "TimeZone/ExportToCSV",
  SITE_COVERAGE: "SiteCoverage/ExportToCSV",
  COVERAGE_GAP_COLOR_CONFIGURATION: "RVUConfiguration/ExportToCSV",
  SHIFT_HOUR_CONFIGURATION:
    "ShiftHourConfiguration/ShiftHourConfigurationReportExportToCSV",
  LICENSE_MAPPING: "StateLicense/ExportLicenseMappingToCSV",
  PRIVILEGES_MAPPING: "LicensePrivilegeMapping/ExportPrivilegesMappingToCSV",
  READING_STATUS_MAPPING:
    "LicensePrivilegeMapping/ExportReadingStatusMappingToCSV",
  LICENSE_MAPPING: "LicensePrivilegeMapping/ExportLicenseMappingToCSV",
  DEFINE_MISMATCH: "LicensePrivilegeMapping/ExportDefineMismatchToCSV",
  DLS_CONFIGURATION: "DLSConfiguration/ExportConfigurationDetils",
  SITES_WITHOUT_DLS: "DLSConfiguration/ExportDLSSiteDetils",
  BLOCK_PLANNING_COLOR_CONFIGURATION:
    "BlockPlanningColorConfiguration/ExportToCSV",
  TASK_CONFIGURATION: "Task/TaskExportToCSV",
  SIMULATOR_COLOR_CONFIGURATION: "SimulatorColorConfiguration/ExportToCSV",
  HOLIDAY_DEMAND_PLANNER: "Holiday/ExportHolidayCoveragePlanDetails",
  RAD_PROFILE_ASSOCIATED_SITES: "Radiologist/ExportToCSVAssociatedSites",
  RAD_CAPACITY: "RadCapacity/DownloadSampleRadCapacityInputTemplete",
  RAD_CAPACITY_FILE: "RadCapacity/DownloadRadCapacityFile",
  RAD_CAPACITY_EXCEPTION_FILE: "RadCapacity/DownloadRadCapacityExceptionFile",
  SITE_LIST: "SiteManagement/ExportToCSV",
  SITE_CUSTOM_VIEW: "SiteManagement/ExportFacilityView",
  UNASSIGNED_SITE_LIST: "SiteManagement/UnAssignedExportToCSV",
  CUSTOM_VIEW_LIST: "Radiologist/ExportCustomViewToCSV",
  ONBOARDING_SITE_DEMAND_PLANNER:
    "SiteOnboardingPlanner/SiteOnBoardingDemandPlannerExportToCSV",
  CAPACITY_VS_DEMAND:
    "CapacityVsDemand/ExportToCSVCapacityVsDemandReport?CapacityVsDemandTableID",
  SCHEDULING_CALENDAR: "SchedulingCalendar/ExportToCSV",
  PROVIDER_REQUEST: "ProviderRequest/ExportToCSV",
  REGIONAL_PRACTICE: "RegionalPractice/ExportToCSV",
  CAPACITY_TABLE_BLOCK_PLANNING_ACTIVE_RAD:
    "CapacityTableBlockPlanning/ActiveRadExportToCSV",
  CAPACITY_TABLE_BLOCK_PLANNING_PENDING_RAD:
    "CapacityTableBlockPlanning/PendingRadExportToCSV",
  CAPACITY_TABLE_BLOCK_PLANNING_OFFBOARDING_RAD:
    "CapacityTableBlockPlanning/OffboardingRadExportToCSV",
  //Volume Trend Report
  VOLUME_TREND_REPORT: "ExamData/GenerateVolumeTrendReport",
  STAFF_CATEGORY: "StaffCategory/ExportToCSV",
  STAFF_PRIMARY_LOCATION: "StaffPrimaryWorkLocation/ExportToCSV",
  MODALITY: "ModalitiesManagement/ExportToCSV",
  PRIORITY: "PrioritiesManagement/ExportToCSV",
  SPECIALTY_CASES: "RadSpecialityCase/ExportToCSV",
  STAFFING_AGENCY: "StaffingAgency/ExportToCSV",
  PROVIDER_DOC_TYPE: "RadDocumentType/ExportToCSV",
  PROVIDER_NOTE_TYPE: "RadNoteType/ExportToCSV",
  DESIGNATION_USER: "DesignationUser/ExportToCSV",
};
